// departmentSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { DepartmentState } from './departmentTypes';
import { createDepartment, updateDepartment, deleteDepartment, fetchDepartmentById, fetchAllDepartments } from './departmentAction';

const initialState: DepartmentState = {
    departments: [],
    selectedDepartment: undefined,
    loading: false,
    error: undefined,
};

const departmentSlice = createSlice({
    name: 'departments',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Create Department
            .addCase(createDepartment.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(createDepartment.fulfilled, (state, action) => {
                state.loading = false;
                state.departments.push(action.payload);
            })
            .addCase(createDepartment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Update Department
            .addCase(updateDepartment.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(updateDepartment.fulfilled, (state, action) => {
                state.loading = false;
                const index = state.departments.findIndex(dep => dep.Id === action.payload.Id);
                if (index !== -1) {
                    state.departments[index] = action.payload;
                }
            })
            .addCase(updateDepartment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Delete Department
            .addCase(deleteDepartment.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(deleteDepartment.fulfilled, (state, action) => {
                state.loading = false;
                state.departments = state.departments.filter(dep => dep.Id !== action.meta.arg.departmentId);
            })
            .addCase(deleteDepartment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Fetch Department by ID
            .addCase(fetchDepartmentById.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchDepartmentById.fulfilled, (state, action) => {
                state.loading = false;
                state.selectedDepartment = action.payload;
            })
            .addCase(fetchDepartmentById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Fetch All Departments
            .addCase(fetchAllDepartments.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchAllDepartments.fulfilled, (state, action) => {
                state.loading = false;
                state.departments = action.payload.data;
            })
            .addCase(fetchAllDepartments.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default departmentSlice.reducer;
